import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader } from "lucide-react";
import { useState } from "react";

interface TutorialDialogProps {
    title: React.ReactNode;
    description: React.ReactNode;
    scribeHowEmbedLink: string;
    dialogTrigger?: React.ReactNode;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}

export function TutorialDialog({ title, description, scribeHowEmbedLink, dialogTrigger = null, open, onOpenChange }: Readonly<TutorialDialogProps>) {
    const [loading, setLoading] = useState(true);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            {dialogTrigger}
            <DialogContent
                className="max-w-5xl md:max-w-7xl"
            >
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="text-sm">{description}</DialogDescription>
                </DialogHeader>

                <div className="relative w-full h-full">
                    {loading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-100" id="iframe-loader">
                            <Loader className="w-6 h-6 animate-spin"></Loader>
                        </div>
                    )}
                    <iframe
                        title={scribeHowEmbedLink}
                        src={scribeHowEmbedLink}
                        style={{ height: 'calc(100svh - 130px)' }}
                        onLoad={() => setLoading(false)}
                        className="w-full border rounded-md"
                    />
                </div>

            </DialogContent>
        </Dialog>
    )
}